module.exports = {
  portal: {
    title: "Portal: single digital workspace",
    subtitle: "Corporate platform for access management, document flow, accounting, laboratory operations, transport, ACS and integrations.",
    summaryTitle: "What the portal solves",
    summaryText: "Portal consolidates distributed business processes in one /app interface. Users access only allowed applications, and every action is auditable.",
    summaryPoints: [
      "AD and FBA accounts in one access model",
      "Modular apps/* with consistent permission rules",
      "Integrations: 1C, banking APIs, Kontur.Focus, DaData, ACS, FortMonitor",
      "Central logging and AI assistant for analysis"
    ],
    stats: [
      { value: "35+", label: "applications" },
      { value: "10+", label: "integrations" },
      { value: "24/7", label: "log monitoring" }
    ],
    integrationsTitle: "Integration map",
    integrationsSubtitle: "The donut chart shows integration domains in the platform stack",
    integrationShares: [
      { name: "Active Directory / LDAP", value: 18, color: "#3b82f6" },
      { name: "1C + Banking APIs", value: 22, color: "#10b981" },
      { name: "ACS / Mikrotik", value: 16, color: "#f59e0b" },
      { name: "Kontur.Focus / DaData", value: 14, color: "#ef4444" },
      { name: "FortMonitor / Maps", value: 12, color: "#a855f7" },
      { name: "OpenAI / WOPI / Messengers", value: 18, color: "#06b6d4" }
    ],
    appsTitle: "Application viewer",
    appsSubtitle: "Choose a domain and inspect available applications",
    openAppLabel: "Open module",
    appFilters: [
      { code: "all", label: "All" },
      { code: "document", label: "Document flow" },
      { code: "accounting", label: "Accounting" },
      { code: "laboratory", label: "Laboratory" },
      { code: "control", label: "ACS and monitoring" },
      { code: "platform", label: "Platform" }
    ],
    appCatalog: [
      {
        title: "contragents",
        area: "Document flow",
        href: "/app/pw/contragents",
        categories: ["all", "document"],
        description: "Counterparty profiles with data enrichment and risk checks.",
        features: ["DaData and Kontur.Focus", "Change history", "Responsible alerts"]
      },
      {
        title: "waybills",
        area: "Transport",
        href: "/app/pw/waybills",
        categories: ["all", "document", "control"],
        description: "Trip, route and fuel accounting with printable waybill forms.",
        features: ["Fleet linkage", "Trip analytics", "PDF forms"]
      },
      {
        title: "banksoperations",
        area: "Accounting",
        href: "/app/accounting/banksoperations",
        categories: ["all", "accounting"],
        description: "Bank operation import and processing with payment control.",
        features: ["API auto-import", "Amount control", "Contract mapping"]
      },
      {
        title: "lab_equipment",
        area: "Laboratory",
        href: "/app/laboratory/lab_equipment",
        categories: ["all", "laboratory"],
        description: "Laboratory equipment records and technical asset tracking.",
        features: ["Groups and passports", "NDT linkage", "Service journal"]
      },
      {
        title: "chatgpt",
        area: "Platform",
        href: "/app/system/chatgpt",
        categories: ["all", "platform"],
        description: "AI assistant for file, log and operational data analysis.",
        features: ["Dialogue history", "Log analysis", "Attachment processing"]
      },
      {
        title: "syslogserver",
        area: "ACS and monitoring",
        href: "/app/system/syslogserver",
        categories: ["all", "control", "platform"],
        description: "Centralised audit of user and system events.",
        features: ["Event filters", "Report export", "Action timeline"]
      }
    ],
    cardsTitle: "Technical architecture",
    cardsSubtitle: "Core components for reliability and scalability",
    cards: [
      { riIcon: "RiReactjsLine", title: "Client SPA", text: "React + Redux + Ant Design with desktop and widgets on /app." },
      { riIcon: "RiNodejsLine", title: "Node.js Backend", text: "Express, socket.io, API gateways and SSR pages." },
      { riIcon: "RiDatabase2Line", title: "Data Layer", text: "MongoDB with separated system and business domains." },
      { riIcon: "RiSettings4Line", title: "Service Scheduler", text: "Background jobs for synchronisation, cleanup and integrations." }
    ],
    workflowTitle: "Go-live workflow",
    workflowSubtitle: "Step-by-step rollout without disrupting operations",
    workflow: [
      { num: "01", riIcon: "RiSearchLine", title: "Landscape audit", text: "We verify IT landscape, data sources and user roles." },
      { num: "02", riIcon: "RiServerLine", title: "Deployment", text: "We deploy infrastructure and core platform services." },
      { num: "03", riIcon: "RiArrowRightUpLine", title: "Integrations", text: "We connect 1C, AD, banks, ACS and external APIs in phases." },
      { num: "04", riIcon: "RiCheckboxCircleLine", title: "Operational launch", text: "We train teams, formalise processes and start support." }
    ],
    listTitle: "Business outcome",
    listSubtitle: "What your organisation gets after implementation",
    listItems: [
      "Single digital workflow instead of disconnected tools",
      "Lower manual effort and reduced data duplication",
      "Transparent user activity and security traceability",
      "Faster access to analytics for management"
    ],
    ctaTitle: "Request a demo",
    ctaText: "We will present Portal on your real scenarios and prepare an implementation plan.",
    primaryHref: "/pages/contact",
    primaryLabel: "Contact us",
    secondaryHref: "/pages/services",
    secondaryLabel: "View services",
    presentationBtn: "View presentation",
    presentationHref: "/pages/presentation-app",
    forWhomTitle: "Who Portal is for",
    forWhomSubtitle: "Built for industrial enterprises with complex multi-division structures",
    forWhomItems: [
      { riIcon: "RiBuildingLine", title: "Industrial companies", text: "Enterprises with multiple divisions and complex internal processes." },
      { riIcon: "RiGroupLine", title: "Enterprise IT teams", text: "Teams that need a manageable platform without cloud dependencies." },
      { riIcon: "RiUserStarLine", title: "Managers and analysts", text: "Leaders who need up-to-date data and decision-making tools." },
      { riIcon: "RiAccountBoxLine", title: "End users", text: "Staff who access only their allowed apps through a single interface." }
    ]
  }
};
